import { render, staticRenderFns } from "./TrainingVideo.vue?vue&type=template&id=4b66d08a&scoped=true"
import script from "./TrainingVideo.vue?vue&type=script&lang=js"
export * from "./TrainingVideo.vue?vue&type=script&lang=js"
import style0 from "./TrainingVideo.vue?vue&type=style&index=0&id=4b66d08a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b66d08a",
  null
  
)

export default component.exports